import { useContext, useEffect, useState } from "react";
import Psfcards from "./Psfcards";
import { FilterContext } from "../context/Filter";
import { fetchdssatbarchart, fetchpsf, fetchpsfbarchart, fetchpsfservice, fetchcesbarchart, fetchpsfchart2, fetchcesbarchart2, fetchdssat2 } from "./CustSearch/apiSearch";
import Psfbarchart2 from "./Graphs/BarGraph/Psfchart2";

const Metriccard = () => {
    const [data, setData] = useState({});      // Sales data
    const [data2, setData2] = useState({});    // Service data
    const [data3, setData3] = useState([]);    // PSF bar chart data
    const [data4, setData4] = useState([]);    // CES bar chart data
    const [data5, setData5] = useState([]);    // DSSAT bar chart data
    const [data6, setData6] = useState([]);    // PSF bar chart data (service)
    const [data7, setData7] = useState([]);    // CES bar chart data (service)
    const [data8, setData8] = useState([]);    // DSSAT bar chart data (service)
    const { selectedYear, setSelectedYear } = useContext(FilterContext);



    const [loading, setLoading] = useState(false);
    const { arn: parArn, childArn } = useContext(FilterContext);

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;
    const payload = { [key]: value, selectedYear: selectedYear };




    const fetchData = async () => {
        setLoading(true);
        try {
            // 1. Fetch Sales data
            const result1 = await fetchpsf(payload);
            setData(result1 || {});

            // 2. Fetch Service data
            const result2 = await fetchpsfservice(payload);
            if (result2 && result2.result) {
                setData2(result2.result);
            } else {
                setData2(result2 || {});
            }

            // 3. Fetch PSF bar chart data (sales)
            const result3 = await fetchpsfbarchart(payload);
            if (Array.isArray(result3)) {
                setData3(result3);
            } else if (result3 && Array.isArray(result3.result)) {
                setData3(result3.result);
            } else {
                console.warn("Unexpected data structure for PSF bar chart:", result3);
                setData3([]);
            }

            // 4. Fetch CES bar chart data (sales)
            try {
                const result4 = await fetchcesbarchart(payload);
                if (Array.isArray(result4)) {
                    setData4(result4);
                } else if (result4 && Array.isArray(result4.result)) {
                    setData4(result4.result);
                } else {
                    console.warn("Unexpected data structure for CES bar chart:", result4);
                    setData4([]);
                }
            } catch (cesError) {
                console.warn("CES API not available or failed:", cesError);
                setData4([]);
            }

            // 5. Fetch DSSAT bar chart data (sales)
            const result5 = await fetchdssatbarchart(payload);
            if (Array.isArray(result5)) {
                setData5(result5);
            } else if (result5 && Array.isArray(result5.result)) {
                setData5(result5.result);
            } else {
                console.warn("Unexpected data structure for DSSAT bar chart:", result5);
                setData5([]);
            }

            // 6. Fetch PSF bar chart data (service)
            const result6 = await fetchpsfchart2(payload);
            if (Array.isArray(result6)) {
                setData6(result6);
            } else if (result6 && Array.isArray(result6.result)) {
                setData6(result6.result);
            } else {
                setData6([]);
            }

            // 7. Fetch CES bar chart data (service)
            const result7 = await fetchcesbarchart2(payload);
            if (Array.isArray(result7)) {
                setData7(result7);
            } else if (result7 && Array.isArray(result7.result)) {
                setData7(result7.result);
            } else {
                setData7([]);
            }

            // 8. Fetch DSSAT bar chart data (service)
            const result8 = await fetchdssat2(payload);
            if (Array.isArray(result8)) {
                setData8(result8);
            } else if (result8 && Array.isArray(result8.result)) {
                setData8(result8.result);
            } else {
                console.warn("Unexpected data structure for DSSAT bar chart 2:", result8);
                setData8([]);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            setData({});
            setData2({});
            setData3([]);
            setData4([]);
            setData5([]);
            setData6([]);
            setData7([]);
            setData8([]);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (!value) return;
        fetchData();

    }, [parArn, childArn, selectedYear]);

    const TrendingUpIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 17l6-6 4 4 8-8" />
        </svg>
    );

    const SettingsIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15.5A3.5 3.5 0 1115.5 12 3.5 3.5 0 0112 15.5z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09a1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06-.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
        </svg>
    );

    const salesMetrics = [
        { icon: TrendingUpIcon, label: "PSF Score", value: "0%", valueColor: "text-blue-500" },
        { icon: SettingsIcon, label: "Customer Effort", value: "0", valueColor: "text-green-500" },
        { icon: TrendingUpIcon, label: "Dissatisfaction", value: "0%", valueColor: "text-red-500" },
    ];

    const serviceMetrics = [
        { icon: SettingsIcon, label: "PSF Score", value: "0%", valueColor: "text-blue-500" },
        { icon: TrendingUpIcon, label: "Customer Effort", value: "0", valueColor: "text-green-500" },
        { icon: SettingsIcon, label: "Dissatisfaction", value: "0%", valueColor: "text-red-500" },
    ];

    if (loading) {
        return (
            <div className="bg-gray-50 w-full justify-center justify-items-center ">
                <div className="flex gap-2 ">
                    <div className="bg-white p-2 rounded-lg shadow-md animate-pulse w-96 flex-1">
                        <div className="h-6 bg-gray-200 rounded mb-4"></div>
                        <div className="h-32 bg-gray-200 rounded"></div>
                    </div>
                    <div className="bg-white p-8 rounded-lg shadow-md animate-pulse flex-1">
                        <div className="h-6 bg-gray-200 rounded mb-4"></div>
                        <div className="h-32 bg-gray-200 rounded"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 w-full justify-center justify-items-center ">
            <div className="flex gap-4">
                <Psfcards
                    title="Sales"
                    icon={TrendingUpIcon}
                    iconBgColor="bg-blue-500"
                    metrics={salesMetrics}
                    psfscore={data.psf}
                    psfces={data.ces}
                    psdssat={data.dssat}
                    year={data.key}
                    barChart={<Psfbarchart2 data={data3} dataKey="psf" />}
                    cesChart={<Psfbarchart2 data={data4} dataKey="ces" />}
                    DssatChart={<Psfbarchart2 data={data5} dataKey="dssat" />}
                />
                <Psfcards
                    title="Service"
                    icon={SettingsIcon}
                    iconBgColor="bg-green-500"
                    metrics={serviceMetrics}
                    psfscore={data2.psf_}
                    psfces={data2.ces_}
                    psdssat={data2.dssat_}
                    year={data2.key}
                    barChart={<Psfbarchart2 data={data6} dataKey="psf" />}
                    cesChart={<Psfbarchart2 data={data7} dataKey="ces" />}
                    DssatChart={<Psfbarchart2 data={data8} dataKey="dssat" />}
                />
            </div>
        </div>
    );
};

export default Metriccard;